import { RootState } from '~/store';

export const getIsUpdatingBillingInformation = (state: RootState) => state.accountReducer.isUpdating;
export const getLoggedInUser = (state: RootState) => state.accountReducer;
